window.requestAnimationFrame =
  window.requestAnimationFrame ||
  window.mozRequestAnimationFrame ||
  window.webkitRequestAnimationFrame ||
  window.msRequestAnimationFrame ||
  function (timeOutFn) {
    return setTimeout(timeOutFn, 1000 / 60);
  };
window["prismCartDesktop3199V1"] = function () {
  if (
    typeof jQuery !== typeof undefined &&
    jQuery("form.cart tr .cart-flex-item").length &&
    !jQuery(".prismCartDesktop3199V1").length
  ) {
    jQuery("body").addClass("prismCartDesktop3199V1");
    jQuery("head").prepend(
      '<meta name="viewport" content="width=device-width, initial-scale=1">'
    );
    // shiftCartRemoveButton3199V1();
    jQuery(document).on("click", ".cart__qty .qtyBtn", function (e) {
      e.preventDefault();

      var dataQty = jQuery(this).attr("data-qty");
      var qtyInput = jQuery(this).parent().find(".cart__qty-input");
      var qtyVal = parseInt(qtyInput.val());
      if (dataQty == "increase") {
        qtyVal++;
        qtyInput.val(qtyVal).change();

        if (jQuery(qtyInput).val() >= 1) {
          jQuery(qtyInput).parent().addClass("processing");
          jQuery(qtyInput).attr("data-val", jQuery(qtyInput).val());
          jQuery.ajax({
            url: jQuery("form.cart").attr("action"),
            method: "POST",
            data: jQuery("form.cart").serialize(),
            success: function () {
              setCartPagePricing3199V1();
              jQuery(".cart .cartQtyBox").removeClass("processing");
              jQuery(
                ".template-cart .cart__footer .grid__item .btn[name=checkout]"
              ).removeAttr("disabled");
            },
            error: function (e) {
              console.log("Unable to update the cart page", e);
              setCartPagePricing3199V1();
              jQuery(".cart .cartQtyBox").removeClass("processing");
            },
          });
        } else {
          if (confirm("Are you sure want to remove this item from the cart?")) {
            jQuery(
              '.cart__footer .grid__item .cart__update[name="update"]'
            ).click();
          } else {
            jQuery(this).val(jQuery(this).attr("data-val"));
          }
        }
      } else {
        qtyVal--;
        qtyInput.val(qtyVal).change();

        if (jQuery(qtyInput).val() >= 1) {
          jQuery(qtyInput).parent().addClass("processing");
          jQuery(qtyInput).attr("data-val", jQuery(qtyInput).val());
          jQuery.ajax({
            url: jQuery("form.cart").attr("action"),
            method: "POST",
            data: jQuery("form.cart").serialize(),
            success: function () {
              setCartPagePricing3199V1();
              jQuery(".cart .cartQtyBox").removeClass("processing");
              jQuery(
                ".template-cart .cart__footer .grid__item .btn[name=checkout]"
              ).removeAttr("disabled");
            },
            error: function (e) {
              console.log("Unable to update the cart page", e);
              setCartPagePricing3199V1();
              jQuery(".cart .cartQtyBox").removeClass("processing");
            },
          });
        } else {
          if (confirm("Are you sure want to remove this item from the cart?")) {
            jQuery(qtyInput).parent().addClass("processing");
            jQuery(qtyInput).attr("data-val", jQuery(qtyInput).val());
            jQuery.ajax({
              url: jQuery("form.cart").attr("action"),
              method: "POST",
              data: jQuery("form.cart").serialize(),
              success: function () {
                setCartPagePricing3199V1();
                jQuery(".cart .cartQtyBox").removeClass("processing");
                jQuery(
                  ".template-cart .cart__footer .grid__item .btn[name=checkout]"
                ).removeAttr("disabled");
                location.reload();
              },
              error: function (e) {
                console.log("Unable to update the cart page", e);
                setCartPagePricing3199V1();
                jQuery(".cart .cartQtyBox").removeClass("processing");
              },
            });
            jQuery(
              '.cart__footer .grid__item .cart__update[name="update"]'
            ).click();
          } else {
            jQuery(this).val(jQuery(this).attr("data-val"));
          }
        }
      }
      //return false;
    });
  } else {
    window.requestAnimationFrame(prismCartDesktop3199V1);
  }
};
window.prismCartDesktop3199V1();
// function shiftCartRemoveButton3199V1() {
//   jQuery("tr.cart__row.border-bottom.cart-flex").each(function () {
//     jQuery(this).find("td:last").addClass("lastColumn");
//     jQuery(this)
//       .find(".cart__remove")
//       .appendTo(jQuery(this).find("td:last"))
//       .addClass("removeItemCrossBtn");
//     if (!jQuery(this).find(".cartQtyBox").length) {
//       jQuery(this)
//         .find(".cart__qty-input")
//         .attr("type", "text")
//         .attr("onkeypress", "return isNumberKey3199V1(event)")
//         .wrap('<div class="cartQtyBox"></div>');
//     }
//     jQuery(this)
//       .find(".cart__qty-input")
//       .before(
//         '<a href="#" data-qty="decrease" class="qty-decrease qtyBtn"><img src="https://useruploads.visualwebsiteoptimizer.com/useruploads/176372/images/dfe95727d96083273e0a058a2c39bb9b_minusblack.png" alt="" /></a>'
//       );
//     jQuery(this)
//       .find(".cart__qty-input")
//       .after(
//         '<a href="#" data-qty="increase" class="qty-increase qtyBtn"><img src="https://useruploads.visualwebsiteoptimizer.com/useruploads/176372/images/6955bdc75c48ebb036227a76d6048355_plusblack.png" alt="" /></a>'
//       );
//   });
// }
function setCartPagePricing3199V1() {
  var totalPrice = 0;
  jQuery("tr.cart__row.border-bottom.cart-flex").each(function () {
    var qty = jQuery(this).find(".cart__qty-input").val();

    qty = parseInt(qty);
    var unitPrice = jQuery(this).find("td.cart__price-wrapper").text();

    unitPrice = unitPrice.trim();
    unitPrice = unitPrice
      .replace("$", "")
      .replace(/,/g, "")
      .replace(/\s/g, "")
      .replace("Edit", "")
      .replace("Cancel", "");
    //alert(unitPrice);
    unitPrice = parseFloat(unitPrice);
    var itemTotal = parseFloat(qty * unitPrice);

    totalPrice = parseFloat(totalPrice) + itemTotal;

    itemTotal = round2Fixed3199V1(itemTotal);
    itemTotal = numberWithCommas3199V1(itemTotal);
    jQuery(this)
      .find(".lastColumn div")
      .text("$" + itemTotal);
    //jQuery(this).find(".lastColumn div").text("$" + "hello");
  });
  if (totalPrice >= 0) {
    totalPrice = round2Fixed3199V1(totalPrice);
    totalPrice = numberWithCommas3199V1(totalPrice);
    jQuery(".cart__subtotal").text("$" + totalPrice);
    var miniCart = jQuery("div#CartCount .cart-total");
    var miniCartPricing = miniCart.html().split("$");
    totalPrice = totalPrice.replace(".00", "");
    jQuery("div#CartCount .cart-total").text("$" + totalPrice);
  }
}
function numberWithCommas3199V1(x) {
  return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
}
function round2Fixed3199V1(value) {
  value = +value;
  if (isNaN(value)) return NaN;
  // Shift
  value = value.toString().split("e");
  value = Math.round(+(value[0] + "e" + (value[1] ? +value[1] + 2 : 2)));
  // Shift back
  value = value.toString().split("e");
  return (+(value[0] + "e" + (value[1] ? +value[1] - 2 : -2))).toFixed(2);
}
function isNumberKey3199V1(evt) {
  var charCode = evt.which ? evt.which : evt.keyCode;
  if (charCode > 31 && (charCode < 48 || charCode > 57)) return false;
  return true;
}
jQuery(".mycontinue a").text("Continue Shopping");
